<app-modal-shell [config]="modalConfig">
  <div modal-content class="membership-choice">
    <p>La actividad ministerial abarca varias comunidades. El miembro puede desarrollar actividad en todas ellas, pero debe tener una sola comunidad de pertenencia.</p>
    <p id="membership-choice-description">Elegí en cuál quedará su pertenencia. Si cambia la comunidad actual, también se registrará el pase con fecha <strong>{{ data.effectiveDateLabel }}</strong>.</p>
    <mat-radio-group [formControl]="communityControl" aria-label="Comunidad de pertenencia" aria-describedby="membership-choice-description">
      <mat-radio-button *ngFor="let community of data.communities" [value]="community.id">
        <span>{{ community.name }}</span>
        <small *ngIf="community.ancestorNames?.length">{{ community.ancestorNames?.join(' › ') }}</small>
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <ng-container modal-actions>
    <button mat-button type="button" (click)="cancel()">Volver al formulario</button>
    <button mat-flat-button type="button" color="primary" [disabled]="communityControl.invalid" (click)="confirm()">Confirmar y registrar</button>
  </ng-container>
</app-modal-shell>
